
import React from 'react';
import { Slider } from '@/components/ui/slider';
import { cn } from '@/lib/utils';

interface SliderInputProps {
  min?: number;
  max?: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  leftLabel?: string;
  rightLabel?: string;
  className?: string;
  showValue?: boolean;
}

const SliderInput: React.FC<SliderInputProps> = ({
  min = 0,
  max = 100,
  step = 1,
  value,
  onChange,
  leftLabel,
  rightLabel,
  className,
  showValue = true,
}) => {
  const handleValueChange = (values: number[]) => {
    onChange(values[0]);
  };

  return (
    <div className={cn("w-full", className)}>
      <div className="mb-6">
        <Slider
          defaultValue={[value]}
          min={min}
          max={max}
          step={step}
          onValueChange={handleValueChange}
          className="my-6"
        />
        
        <div className="flex justify-between mt-1">
          {leftLabel && <span className="text-sm text-gray-600">{leftLabel}</span>}
          {showValue && <span className="text-sm font-medium">{value} {max === 7 ? 'days' : ''}</span>}
          {rightLabel && <span className="text-sm text-gray-600">{rightLabel}</span>}
        </div>
      </div>
    </div>
  );
};

export default SliderInput;
